import React, { useMemo } from "react";

import countries from "i18n-iso-countries";
import { useTranslation } from "react-i18next";

import { Select } from "antd";

import { Inscription } from "../../inscription";

import styles from "./styles.module.scss";

export interface MarketSelectorProps {
  markets: string[];
  value?: string;
  onSelect?: (market?: string) => void;
}

export const MarketSelector: React.FC<MarketSelectorProps> = (props) => {
  const { t } = useTranslation("market_selector");
  const { markets, value, onSelect } = props;

  const options = useMemo(() => {
    let values = markets;
    if (values.length === 0) {
      if (value) {
        values = [value];
      }
    }

    return values.map((market, idx) => {
      const validCountry = countries.isValid(market);

      const offset = 127397;
      const emojiCode = market.toUpperCase().replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + offset));

      return {
        value: market.toUpperCase(),
        label: (
          <React.Fragment key={`market-option-${idx}`}>
            <span className={styles.flagIcon} aria-invalid={!validCountry}>
              {validCountry ? emojiCode : "🏳️‍🌈"}
            </span>
            <span className={styles.option}>{market.toUpperCase()}</span>
          </React.Fragment>
        ),
      };
    });
  }, [markets, value]);

  return (
    <Inscription title={t("title")}>
      <Select
        showSearch={options.length > 0}
        onSelect={onSelect}
        className={styles.select}
        value={value}
        placeholder={
          <div>
            <span role="img" title="world">
              🌏
            </span>
            <span className={styles.option}>{t("options.all")}</span>
          </div>
        }
        allowClear
        onClear={onSelect}
        options={options}
      />
    </Inscription>
  );
};
